<script setup lang="ts">
import SettingProfileView from '../../views/SettingProfileView/SettingProfileView.vue';
import { styleFn } from 'shared/composables/usePage';
</script>

<template>
  <q-page
    padding
    :style-fn="styleFn"
    class="column"
  >
    <div class="col fit">
      <setting-profile-view />
    </div>
  </q-page>
</template>
